import './CauseAndEffectEditor.scss';
import CauseAndEffectEditorComponent from './editor/CauseAndEffectEditorComponent';
import { filterUndefined } from '../../../../utils/FilterUndefinedObject';

/**
 * Lesson activity for Cause and Effect
 */
const defaultProps = {
  causeCards: [],
  effectCards: [],
  selectedIndex: 0,
  isCauseSelected: true,
  selectedSection: undefined,
  onImageSelected: () => {},
  onTextSelected: () => {},
  onAudioSelected: () => {},
};
export default function CauseAndEffectEditor(props) {
  const {
    causeCards,
    effectCards,
    selectedIndex,
    isCauseSelected,
    selectedSection,
    onImageSelected,
    onTextSelected,
    onAudioSelected,
  } = { ...defaultProps, ...filterUndefined(props) };
  return (
    <div data-test='cause-and-effect-editor' className={`cause-and-effect-editor cause-length-${causeCards.length} vizzle-cause-and-effect-card-editor`}>
      {causeCards.map((cc, index) => (
        <CauseAndEffectEditorComponent
          key={`cause-and-effect-thumbnail-${index}`}
          causeCard={cc}
          effectCard={effectCards[index]}
          isSelected={index === selectedIndex}
          isCauseSelected={isCauseSelected}
          selectedSection={selectedSection}
          onImageSelected={(param) => onImageSelected({ ...param, selectedIndex: index })}
          onTextSelected={(param) => onTextSelected({ ...param, selectedIndex: index })}
          onAudioSelected={(param) => onAudioSelected({ ...param, selectedIndex: index })}
        />
      ))}
    </div>
  );
}
